module.exports = __webpack_public_path__ + "static/media/24.0e3960c4.jpg";